import * as constants from './constants';

export function uploadImage(payload) {
  return {
    type: constants.UPLOAD_IMAGE,
    payload
  };
}

export function uploadImageDone(payload) {
  return {
    type: constants.UPLOAD_IMAGE_DONE,
    payload
  };
}

export function uploadImageFail(payload) {
  return {
    type: constants.UPLOAD_IMAGE_FAIL,
    payload
  };
}
